<div class="layout-footer">
  <span [title]="statusString | async">
    &copy; {{ year }} {{isPropak ? 'Propak' : 'Pallet Logistics of America' }}
  </span>
    <!--
    <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-4 logo-container-outer">
            <a href="/" class="logo-container">
                <img src="assets/layout/images/ecuador-orange-logo.png" alt="ecuador-layout" />
                <span class="app-name">Premium PrimeFaces Application Template</span>
            </a>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-8" style="text-align:center">
            <div id="footer-menu">
                <div class="ui-g-12 ui-md-6 ui-lg-3 footer-box">
                    <span>OVERVIEW</span>
                    <a href="#primefaces">Why PrimeFaces</a>
                    <a href="#prime">Who Uses PrimeFaces</a>
                    <a href="#testimonials">Testimonials</a>
                    <a href="#licence">License</a>
                </div>
            </div>
        </div>
    </div>
    -->
</div>
